<div class="popup__backsplash" (click)="clickedOutside($event)">
  <div id="full-pop-up" class="popup__card fadeInAnimation">
    <ng-content></ng-content>
  </div>
</div>
